import { useAuth } from "@clerk/clerk-react";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { apiRequest, getQueryFn } from "@/lib/queryClient";

export function useApiRequest() {
  const { getToken } = useAuth();

  return {
    apiRequest: async (
      method: string,
      url: string,
      data?: unknown,
      extraHeaders?: Record<string, string>,
    ) => {
      return apiRequest(method, url, data, getToken, extraHeaders);
    },
  };
}

export function useAuthenticatedQuery<TData = unknown, TError = Error>(
  queryKey: readonly unknown[],
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) {
  const { getToken } = useAuth();

  return useQuery({
    queryKey,
    queryFn: getQueryFn({ on401: "throw", getToken }),
    ...options,
  });
}
